// Event agenda and speakers detail data

export type AgendaItemType = 'keynote' | 'panel' | 'workshop' | 'break' | 'ceremony';

export interface AgendaItem {
  id: string;
  time: string;
  titleZh: string;
  titleEn: string;
  speakerZh?: string;
  speakerEn?: string;
  type: AgendaItemType;
  descZh?: string;
  descEn?: string;
}

export interface EventSpeaker {
  id: string;
  nameZh: string;
  nameEn: string;
  titleZh: string;
  titleEn: string;
  institutionZh: string;
  institutionEn: string;
  photo: string;
}

export interface EventDetail {
  eventId: string;
  agenda: AgendaItem[];
  speakers: EventSpeaker[];
}

export const eventDetails: EventDetail[] = [
  {
    eventId: 'gts-2026',
    speakers: [
      {
        id: 's1',
        nameZh: '张明远',
        nameEn: 'Zhang Mingyuan',
        titleZh: '人工智能研究院院长',
        titleEn: 'Director, Institute for AI',
        institutionZh: '北京大学',
        institutionEn: 'Peking University',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 's2',
        nameZh: '陈慧玲',
        nameEn: 'Prof. Sarah H. Chen',
        titleZh: '量子计算实验室主任',
        titleEn: 'Director, Quantum Computing Lab',
        institutionZh: '麻省理工学院',
        institutionEn: 'MIT',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 's3',
        nameZh: '克劳斯·韦伯',
        nameEn: 'Dr. Klaus Weber',
        titleZh: '可持续材料研究所所长',
        titleEn: 'Director, Sustainable Materials Institute',
        institutionZh: '马克斯·普朗克学会',
        institutionEn: 'Max Planck Society',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 's4',
        nameZh: '李慧芳',
        nameEn: 'Li Huifang',
        titleZh: '首席技术官',
        titleEn: 'Chief Technology Officer',
        institutionZh: '阿里巴巴达摩院',
        institutionEn: 'Alibaba DAMO Academy',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 'a1',
        time: '09:00 – 09:30',
        titleZh: '开幕式暨联盟主席致辞',
        titleEn: 'Opening Ceremony & Chairperson\'s Address',
        speakerZh: '黄晓斌 | 联盟主席',
        speakerEn: 'Huang Xiaobin | Chairperson, GTRA',
        type: 'ceremony',
        descZh: '宣布2026全球科创峰会正式开幕，介绍峰会主题与议程亮点',
        descEn: 'Official opening of the 2026 Global Tech Innovation Summit, introducing themes and agenda highlights',
      },
      {
        id: 'a2',
        time: '09:30 – 10:30',
        titleZh: '主旨演讲：人工智能与人类未来',
        titleEn: 'Keynote: Artificial Intelligence & The Human Future',
        speakerZh: '张明远 | MIT大学人工智能研究院',
        speakerEn: 'Zhang Mingyuan | MIT Institute for AI',
        type: 'keynote',
        descZh: '深度解析AI技术的突破性进展，探讨AI如何重塑科学研究范式，以及人类与AI协同创新的未来图景',
        descEn: 'Deep analysis of AI\'s breakthrough advances, exploring how AI reshapes scientific research paradigms and the future of human-AI collaborative innovation',
      },
      {
        id: 'a3',
        time: '10:30 – 11:00',
        titleZh: '茶歇与交流',
        titleEn: 'Coffee Break & Networking',
        type: 'break',
      },
      {
        id: 'a4',
        time: '11:00 – 12:30',
        titleZh: '圆桌讨论：量子计算产业化路径',
        titleEn: 'Roundtable: Pathways to Quantum Computing Commercialization',
        speakerZh: '陈慧玲 | MIT | 克劳斯·韦伯 | 马普学会',
        speakerEn: 'Sarah H. Chen | MIT | Klaus Weber | Max Planck Society',
        type: 'panel',
        descZh: '汇聚量子计算领域顶尖专家，深入讨论量子优越性、错误纠正与产业落地的核心挑战',
        descEn: 'Top quantum computing experts discuss quantum advantage, error correction, and core challenges of industrial deployment',
      },
      {
        id: 'a5',
        time: '14:00 – 15:30',
        titleZh: '主旨演讲：云原生AI与全球算力基础设施',
        titleEn: 'Keynote: Cloud-Native AI & Global Compute Infrastructure',
        speakerZh: '李慧芳 | 阿里巴巴达摩院',
        speakerEn: 'Li Huifang | Alibaba DAMO Academy',
        type: 'keynote',
        descZh: '分享大规模AI训练基础设施的最新突破，展望全球算力网络的未来格局',
        descEn: 'Sharing latest breakthroughs in large-scale AI training infrastructure and the future landscape of global compute networks',
      },
      {
        id: 'a6',
        time: '15:30 – 17:00',
        titleZh: '工作坊：科技创新政策前沿',
        titleEn: 'Workshop: Frontiers in Tech Innovation Policy',
        speakerZh: '多位政策专家共同主持',
        speakerEn: 'Multiple Policy Experts',
        type: 'workshop',
        descZh: '探讨各国科技创新政策的最新动向，交流实践经验，共同推动有利于科技创新的政策环境',
        descEn: 'Explore the latest developments in national tech innovation policies and exchange practical experiences',
      },
      {
        id: 'a7',
        time: '18:00 – 20:00',
        titleZh: '峰会晚宴暨颁奖典礼',
        titleEn: 'Gala Dinner & Awards Ceremony',
        type: 'ceremony',
        descZh: '表彰年度科技创新卓越贡献奖得主，共庆科创合作成果',
        descEn: 'Recognizing winners of the Annual Tech Innovation Excellence Awards and celebrating collaborative achievements',
      },
    ],
  },
  {
    eventId: 'art-2026',
    speakers: [
      {
        id: 's5',
        nameZh: '张明远',
        nameEn: 'Zhang Mingyuan',
        titleZh: '人工智能研究院院长',
        titleEn: 'Director, Institute for AI',
        institutionZh: '北京大学',
        institutionEn: 'Peking University',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 's6',
        nameZh: '克劳斯·韦伯',
        nameEn: 'Dr. Klaus Weber',
        titleZh: '可持续材料研究所所长',
        titleEn: 'Director, Sustainable Materials Institute',
        institutionZh: '马克斯·普朗克学会',
        institutionEn: 'Max Planck Society',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 'b1',
        time: '09:30 – 10:00',
        titleZh: '欢迎致辞',
        titleEn: 'Welcome Address',
        speakerZh: 'GTRA 代表',
        speakerEn: 'GTRA Representative',
        type: 'ceremony',
      },
      {
        id: 'b2',
        time: '10:00 – 11:30',
        titleZh: '主旨：大语言模型的边界与突破',
        titleEn: 'Keynote: Boundaries and Breakthroughs of Large Language Models',
        speakerZh: '张明远 | 北京大学',
        speakerEn: 'Zhang Mingyuan | Peking University',
        type: 'keynote',
        descZh: '深度探讨LLM的能力边界、幻觉问题及其解决路径，以及多模态AI的最新进展',
        descEn: 'Deep exploration of LLM capability boundaries, hallucination problems and solutions, and latest advances in multimodal AI',
      },
      {
        id: 'b3',
        time: '11:30 – 12:30',
        titleZh: 'AI伦理圆桌：责任、透明与全球治理',
        titleEn: 'AI Ethics Roundtable: Responsibility, Transparency & Global Governance',
        speakerZh: '多位专家联合讨论',
        speakerEn: 'Multiple Experts',
        type: 'panel',
        descZh: '聚焦AI伦理的核心议题，探讨建立负责任AI开发与部署框架的国际路径',
        descEn: 'Focused on core AI ethics topics, exploring international pathways for establishing responsible AI development and deployment frameworks',
      },
      {
        id: 'b4',
        time: '14:00 – 15:30',
        titleZh: '跨学科工作坊：AI赋能科学发现',
        titleEn: 'Interdisciplinary Workshop: AI-Enabled Scientific Discovery',
        speakerZh: '克劳斯·韦伯 | 马普学会',
        speakerEn: 'Dr. Klaus Weber | Max Planck Society',
        type: 'workshop',
        descZh: '探索AI在材料发现、蛋白质结构预测和天文观测中的最新突破性应用',
        descEn: 'Exploring cutting-edge AI applications in materials discovery, protein structure prediction, and astronomical observation',
      },
    ],
  },
  {
    eventId: 'gtf-2026',
    speakers: [
      {
        id: 's7',
        nameZh: '艾哈迈德·拉希迪',
        nameEn: 'Dr. Ahmed Al-Rashidi',
        titleZh: '清洁能源研究中心主任',
        titleEn: 'Director, Clean Energy Research Center',
        institutionZh: '阿卜杜拉国王科技大学',
        institutionEn: 'KAUST',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 'c1',
        time: '09:00 – 10:00',
        titleZh: '开幕主旨：净零排放的科技路径',
        titleEn: 'Opening Keynote: Technology Pathways to Net Zero',
        speakerZh: '艾哈迈德·拉希迪 | KAUST',
        speakerEn: 'Dr. Ahmed Al-Rashidi | KAUST',
        type: 'keynote',
        descZh: '全面梳理清洁能源技术的最新突破，分析实现净零排放目标所需的技术组合',
        descEn: 'Comprehensive review of breakthrough clean energy technologies and analysis of the technology portfolio needed to achieve net-zero emissions',
      },
      {
        id: 'c2',
        time: '10:30 – 12:00',
        titleZh: '专题工作坊：新型光伏技术与储能创新',
        titleEn: 'Workshop: Next-Gen Solar PV & Energy Storage Innovation',
        type: 'workshop',
        descZh: '聚焦钙钛矿太阳能电池、固态电池和新型储能技术的最新研究进展',
        descEn: 'Focused on latest advances in perovskite solar cells, solid-state batteries, and novel energy storage technologies',
      },
    ],
  },
  {
    eventId: 'fms-2026',
    speakers: [],
    agenda: [
      {
        id: 'd1',
        time: '09:30 – 11:00',
        titleZh: '主旨演讲：自动驾驶技术的临界点',
        titleEn: 'Keynote: Autonomous Driving at the Tipping Point',
        type: 'keynote',
        descZh: '回顾自动驾驶技术的发展历程，分析当前技术成熟度与规模商业化的关键挑战',
        descEn: 'Reviewing the development of autonomous driving technology and analyzing current maturity and key challenges for large-scale commercialization',
      },
      {
        id: 'd2',
        time: '11:30 – 12:30',
        titleZh: '圆桌：电动化与智能化的融合发展',
        titleEn: 'Roundtable: Convergence of Electrification and Intelligence',
        type: 'panel',
        descZh: '探讨电动汽车与智能驾驶的融合发展趋势，以及产业链变革的机遇与挑战',
        descEn: 'Exploring the convergence of electric vehicles and intelligent driving, along with opportunities and challenges in industrial chain transformation',
      },
      {
        id: 'd3',
        time: '14:00 – 15:30',
        titleZh: '智慧城市交通系统创新展示',
        titleEn: 'Smart City Transport Innovation Showcase',
        type: 'workshop',
        descZh: '展示全球智慧城市交通系统的最新案例与最佳实践',
        descEn: 'Showcasing the latest cases and best practices in global smart city transportation systems',
      },
    ],
  },
  {
    eventId: 'qcs-2026',
    speakers: [
      {
        id: 's8',
        nameZh: '陈慧玲',
        nameEn: 'Prof. Sarah H. Chen',
        titleZh: '量子计算实验室主任',
        titleEn: 'Director, Quantum Computing Lab',
        institutionZh: '麻省理工学院',
        institutionEn: 'MIT',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 'e1',
        time: '09:00 – 10:30',
        titleZh: '主旨：拓扑量子比特的最新突破',
        titleEn: 'Keynote: Latest Breakthroughs in Topological Qubits',
        speakerZh: '陈慧玲 | MIT',
        speakerEn: 'Prof. Sarah H. Chen | MIT',
        type: 'keynote',
        descZh: '详细介绍拓扑量子比特在抗噪声能力和扩展性方面的最新理论与实验进展',
        descEn: 'Detailed introduction to the latest theoretical and experimental advances in topological qubits in terms of noise resistance and scalability',
      },
      {
        id: 'e2',
        time: '11:00 – 12:30',
        titleZh: '专题：量子算法与经典计算的协同',
        titleEn: 'Session: Quantum-Classical Hybrid Computing',
        type: 'panel',
        descZh: '探讨量子-经典混合计算在优化问题、材料模拟和密码学中的实际应用前景',
        descEn: 'Exploring practical applications of quantum-classical hybrid computing in optimization, materials simulation, and cryptography',
      },
    ],
  },
  {
    eventId: 'lsf-2026',
    speakers: [],
    agenda: [
      {
        id: 'f1',
        time: '09:30 – 11:00',
        titleZh: '主旨演讲：基因组学革命与精准医疗',
        titleEn: 'Keynote: The Genomics Revolution and Precision Medicine',
        type: 'keynote',
        descZh: '回顾基因组学技术的发展历程，展望精准医疗在重大疾病防治中的应用前景',
        descEn: 'Reviewing the development of genomics technology and prospects for precision medicine in the prevention and treatment of major diseases',
      },
      {
        id: 'f2',
        time: '11:30 – 13:00',
        titleZh: '圆桌：合成生物学的伦理边界',
        titleEn: 'Roundtable: Ethical Boundaries of Synthetic Biology',
        type: 'panel',
        descZh: '讨论合成生物学快速发展中的伦理挑战、监管框架与国际协调机制',
        descEn: 'Discussing ethical challenges, regulatory frameworks, and international coordination mechanisms in the rapid development of synthetic biology',
      },
    ],
  },
  // ===== 历史活动详情 2025 =====
  {
    eventId: 'gts-2025',
    speakers: [
      {
        id: 'ps1',
        nameZh: '张明远',
        nameEn: 'Zhang Mingyuan',
        titleZh: '人工智能研究院院长',
        titleEn: 'Director, Institute for AI',
        institutionZh: '北京大学',
        institutionEn: 'Peking University',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 'ps2',
        nameZh: '安娜·索科洛娃',
        nameEn: 'Dr. Anna Sokolova',
        titleZh: '数字经济研究中心主任',
        titleEn: 'Director, Digital Economy Research Center',
        institutionZh: '莫斯科高等经济学院',
        institutionEn: 'HSE Moscow',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 'ps3',
        nameZh: '刘建国',
        nameEn: 'Dr. Liu Jianguo',
        titleZh: '人居环境与智慧城市实验室主任',
        titleEn: 'Director, Smart Cities Lab',
        institutionZh: '同济大学',
        institutionEn: 'Tongji University',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 'p1',
        time: '09:00 – 09:30',
        titleZh: '开幕式暨联盟主席致辞',
        titleEn: 'Opening Ceremony & Alliance Chair\'s Address',
        speakerZh: '王思远 | GTRA联盟主席',
        speakerEn: 'Wang Siyuan | GTRA Alliance Chair',
        type: 'ceremony',
        descZh: '宣布2025峰会开幕，回顾GTRA成立以来的重要里程碑，展望新一年科创合作愿景',
        descEn: 'Official opening of the 2025 Summit, reviewing GTRA milestones and outlining the vision for sci-tech cooperation in the coming year',
      },
      {
        id: 'p2',
        time: '09:30 – 11:00',
        titleZh: '主旨演讲：智能未来——AI如何重塑人类生活',
        titleEn: 'Keynote: Intelligent Future — How AI is Reshaping Human Life',
        speakerZh: '张明远 | 北京大学',
        speakerEn: 'Zhang Mingyuan | Peking University',
        type: 'keynote',
        descZh: '系统阐述AI在医疗、教育、城市治理等领域的深度渗透，探讨人机协作的未来图景',
        descEn: 'Systematically presenting AI\'s deep penetration in healthcare, education, and urban governance, exploring future human-machine collaboration',
      },
      {
        id: 'p3',
        time: '11:00 – 11:30',
        titleZh: '茶歇与交流',
        titleEn: 'Coffee Break & Networking',
        type: 'break',
      },
      {
        id: 'p4',
        time: '11:30 – 13:00',
        titleZh: '圆桌：数字经济与科技创新政策协调',
        titleEn: 'Roundtable: Digital Economy & Tech Innovation Policy Coordination',
        speakerZh: '安娜·索科洛娃 | HSE | 刘建国 | 同济大学',
        speakerEn: 'Anna Sokolova | HSE | Liu Jianguo | Tongji University',
        type: 'panel',
        descZh: '探讨全球数字经济政策框架的协调路径，分析不同国家的监管模式与创新友好型政策实践',
        descEn: 'Exploring coordination paths for global digital economy policy frameworks and analyzing regulatory models and innovation-friendly policy practices across nations',
      },
      {
        id: 'p5',
        time: '14:00 – 16:00',
        titleZh: '工作坊：智慧城市与人居环境创新',
        titleEn: 'Workshop: Smart Cities & Livable Environment Innovation',
        speakerZh: '刘建国 | 同济大学',
        speakerEn: 'Liu Jianguo | Tongji University',
        type: 'workshop',
        descZh: '通过案例研究探讨智慧城市技术在可持续城市发展中的最佳实践，聚焦能源效率与人居质量',
        descEn: 'Exploring best practices of smart city technologies in sustainable urban development through case studies, focusing on energy efficiency and living quality',
      },
      {
        id: 'p6',
        time: '18:00 – 20:00',
        titleZh: '峰会闭幕晚宴',
        titleEn: 'Closing Gala Dinner',
        type: 'ceremony',
        descZh: '总结峰会成果，签署28项合作协议，庆祝GTRA成立五周年',
        descEn: 'Summarizing summit outcomes, signing 28 cooperation agreements, and celebrating the 5th anniversary of GTRA',
      },
    ],
  },
  {
    eventId: 'gts-2024',
    speakers: [
      {
        id: 'qs1',
        nameZh: '王思远',
        nameEn: 'Wang Siyuan',
        titleZh: 'GTRA 创始主席',
        titleEn: 'Founding Chair, GTRA',
        institutionZh: '全球科创圆桌联盟',
        institutionEn: 'Global Tech Roundtable Alliance',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 'qs2',
        nameZh: '玛格达莱纳·诺瓦克',
        nameEn: 'Dr. Magdalena Nowak',
        titleZh: '欧洲创新政策研究所所长',
        titleEn: 'Director, European Institute for Innovation Policy',
        institutionZh: '华沙大学',
        institutionEn: 'University of Warsaw',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 'q1',
        time: '09:00 – 10:00',
        titleZh: 'GTRA 创始峰会开幕典礼',
        titleEn: 'GTRA Inaugural Summit Opening Ceremony',
        speakerZh: '王思远 | GTRA创始主席',
        speakerEn: 'Wang Siyuan | GTRA Founding Chair',
        type: 'ceremony',
        descZh: '宣告GTRA全球合作网络正式成立，发布创始宣言，来自30个国家的代表共同见证历史性时刻',
        descEn: 'Official establishment of the GTRA global cooperation network, release of the founding declaration, with representatives from 30 countries witnessing this historic moment',
      },
      {
        id: 'q2',
        time: '10:00 – 11:30',
        titleZh: '创始主旨演讲：连接全球创新力量',
        titleEn: 'Inaugural Keynote: Connecting Global Innovation Forces',
        speakerZh: '王思远 | GTRA',
        speakerEn: 'Wang Siyuan | GTRA',
        type: 'keynote',
        descZh: '阐述GTRA成立愿景与使命，描绘全球科创合作网络的未来蓝图，呼吁各国科创精英携手共建开放合作的全球创新生态',
        descEn: 'Presenting GTRA\'s founding vision and mission, outlining the future blueprint for a global sci-tech cooperation network, and calling on innovators worldwide to build an open and collaborative global innovation ecosystem',
      },
      {
        id: 'q3',
        time: '11:30 – 13:00',
        titleZh: '圆桌：跨国科技合作的机遇与挑战',
        titleEn: 'Roundtable: Opportunities and Challenges in Cross-Border Tech Cooperation',
        speakerZh: '玛格达莱纳·诺瓦克 | 华沙大学 | 多位创始理事',
        speakerEn: 'Dr. Magdalena Nowak | University of Warsaw | Founding Council Members',
        type: 'panel',
        descZh: '首届跨国科技合作圆桌对话，汇聚来自6大洲的创始理事成员，共同制定GTRA未来三年合作路线图',
        descEn: 'The inaugural cross-border tech cooperation roundtable, bringing together founding council members from 6 continents to develop GTRA\'s three-year cooperation roadmap',
      },
      {
        id: 'q4',
        time: '14:30 – 16:30',
        titleZh: '工作坊：全球科创治理框架研讨',
        titleEn: 'Workshop: Global Sci-Tech Governance Framework Discussion',
        type: 'workshop',
        descZh: '探讨建立跨国科技合作治理机制的核心议题，为GTRA组织架构与运营规范奠定基础',
        descEn: 'Exploring core issues in establishing cross-border tech cooperation governance mechanisms, laying the foundation for GTRA\'s organizational structure and operational standards',
      },
      {
        id: 'q5',
        time: '17:00 – 19:00',
        titleZh: '创始会员合作协议签署仪式暨庆典晚宴',
        titleEn: 'Founding Member Cooperation Agreement Signing Ceremony & Gala Dinner',
        type: 'ceremony',
        descZh: '30个国家的创始成员机构代表共同签署合作宣言，正式启动GTRA全球科创合作网络',
        descEn: 'Representatives from founding member institutions across 30 countries jointly signed the cooperation declaration, officially launching the GTRA global sci-tech cooperation network',
      },
    ],
  },
  {
    eventId: 'qcs-2025',
    speakers: [
      {
        id: 'rs1',
        nameZh: '陈慧玲',
        nameEn: 'Prof. Sarah H. Chen',
        titleZh: '量子计算实验室主任',
        titleEn: 'Director, Quantum Computing Lab',
        institutionZh: '麻省理工学院',
        institutionEn: 'MIT',
        photo: '/images/gtra-logo.png',
      },
      {
        id: 'rs2',
        nameZh: '武田亮介',
        nameEn: 'Dr. Ryosuke Takeda',
        titleZh: '量子信息研究部门主任',
        titleEn: 'Head of Quantum Information Research',
        institutionZh: '理化学研究所（RIKEN）',
        institutionEn: 'RIKEN Institute',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 'r1',
        time: '09:00 – 10:30',
        titleZh: '主旨：量子纠错的最新突破与挑战',
        titleEn: 'Keynote: Latest Breakthroughs and Challenges in Quantum Error Correction',
        speakerZh: '陈慧玲 | MIT',
        speakerEn: 'Prof. Sarah H. Chen | MIT',
        type: 'keynote',
        descZh: '系统回顾量子纠错领域的最新进展，分析表面码、拓扑码等主流方案的优势与局限',
        descEn: 'Systematically reviewing the latest advances in quantum error correction, analyzing the advantages and limitations of mainstream approaches such as surface codes and topological codes',
      },
      {
        id: 'r2',
        time: '10:30 – 11:00',
        titleZh: '茶歇',
        titleEn: 'Coffee Break',
        type: 'break',
      },
      {
        id: 'r3',
        time: '11:00 – 12:30',
        titleZh: '演讲：量子计算与经典高性能计算的协同',
        titleEn: 'Talk: Synergy Between Quantum and Classical HPC',
        speakerZh: '武田亮介 | 理化学研究所',
        speakerEn: 'Dr. Ryosuke Takeda | RIKEN',
        type: 'keynote',
        descZh: '探讨量子-经典混合计算架构在药物研发、材料模拟和优化问题中的前沿应用',
        descEn: 'Exploring frontier applications of quantum-classical hybrid computing architectures in drug discovery, materials simulation, and optimization problems',
      },
      {
        id: 'r4',
        time: '14:00 – 16:00',
        titleZh: '专题讨论：量子优越性验证的标准与方法',
        titleEn: 'Panel: Standards and Methods for Quantum Advantage Verification',
        speakerZh: '多位量子领域专家',
        speakerEn: 'Multiple Quantum Experts',
        type: 'panel',
        descZh: '讨论量子优越性验证的学术标准，分析不同基准测试方法的有效性，探索建立国际共识',
        descEn: 'Discussing academic standards for quantum advantage verification, analyzing the effectiveness of different benchmark testing methods, and exploring international consensus-building',
      },
      {
        id: 'r5',
        time: '16:30 – 17:30',
        titleZh: '联合研究声明发布仪式',
        titleEn: 'Joint Research Statement Release Ceremony',
        type: 'ceremony',
        descZh: '发布2份关于量子计算标准化与国际合作的联合研究声明',
        descEn: 'Release of 2 joint research statements on quantum computing standardization and international cooperation',
      },
    ],
  },
  {
    eventId: 'art-2024',
    speakers: [
      {
        id: 'ss1',
        nameZh: '张明远',
        nameEn: 'Zhang Mingyuan',
        titleZh: '人工智能研究院院长',
        titleEn: 'Director, Institute for AI',
        institutionZh: '北京大学',
        institutionEn: 'Peking University',
        photo: '/images/gtra-logo.png',
      },
    ],
    agenda: [
      {
        id: 's1',
        time: '09:30 – 11:00',
        titleZh: '主旨：大语言模型的安全对齐：进展与挑战',
        titleEn: 'Keynote: LLM Safety Alignment: Progress and Challenges',
        speakerZh: '张明远 | 北京大学',
        speakerEn: 'Zhang Mingyuan | Peking University',
        type: 'keynote',
        descZh: '深入分析LLM安全对齐的最新方法论，探讨RLHF、宪法AI等方向的突破与局限性',
        descEn: 'Deep analysis of the latest methodologies in LLM safety alignment, exploring breakthroughs and limitations of RLHF, Constitutional AI, and related approaches',
      },
      {
        id: 's2',
        time: '11:00 – 12:30',
        titleZh: '圆桌：全球AI监管政策的协调路径',
        titleEn: 'Roundtable: Coordination Pathways for Global AI Regulation',
        speakerZh: '来自6个国家的AI政策专家',
        speakerEn: 'AI Policy Experts from 6 Countries',
        type: 'panel',
        descZh: '比较分析欧盟AI法案、美国行政令、中国AI监管框架的差异与共性，探讨国际协调机制',
        descEn: 'Comparative analysis of EU AI Act, US Executive Orders, and Chinese AI regulatory frameworks, exploring international coordination mechanisms',
      },
      {
        id: 's3',
        time: '14:00 – 15:30',
        titleZh: '工作坊：多模态AI的产业化实践与挑战',
        titleEn: 'Workshop: Industrial Practice and Challenges of Multimodal AI',
        type: 'workshop',
        descZh: '聚焦多模态AI在医疗影像、自动驾驶、内容生成等垂直领域的落地案例与挑战',
        descEn: 'Focusing on deployment cases and challenges of multimodal AI in healthcare imaging, autonomous driving, content generation, and other vertical domains',
      },
    ],
  },
  {
    eventId: 'lsf-2025',
    speakers: [],
    agenda: [
      {
        id: 't1',
        time: '09:30 – 11:00',
        titleZh: '主旨演讲：CRISPR下一代：基因编辑精准化的前沿进展',
        titleEn: 'Keynote: CRISPR Next Generation: Frontier Advances in Gene Editing Precision',
        type: 'keynote',
        descZh: '全面回顾CRISPR基础编辑器、先导编辑等新一代基因编辑技术的最新进展及临床转化前景',
        descEn: 'Comprehensive review of next-generation gene editing technologies including base editors and prime editing, and their clinical translation prospects',
      },
      {
        id: 't2',
        time: '11:00 – 12:30',
        titleZh: '圆桌：mRNA疫苗平台的拓展应用——从新冠到癌症治疗',
        titleEn: 'Roundtable: Expanding mRNA Vaccine Platform — From COVID to Cancer Therapy',
        type: 'panel',
        descZh: '深入探讨mRNA技术在传染病预防以外的拓展应用，特别是在个性化肿瘤免疫治疗领域的前景',
        descEn: 'Deep exploration of mRNA technology applications beyond infectious disease prevention, especially prospects in personalized tumor immunotherapy',
      },
      {
        id: 't3',
        time: '14:00 – 16:00',
        titleZh: '工作坊：AI辅助药物研发——加速新药发现的计算路径',
        titleEn: 'Workshop: AI-Assisted Drug Discovery — Computational Pathways to Accelerate New Drug Development',
        type: 'workshop',
        descZh: '探讨AlphaFold、生成式AI等工具在靶点发现、分子优化和临床试验设计中的应用',
        descEn: 'Exploring applications of AlphaFold, generative AI, and other tools in target discovery, molecular optimization, and clinical trial design',
      },
      {
        id: 't4',
        time: '16:30 – 17:30',
        titleZh: '跨国研究项目孵化签约仪式',
        titleEn: 'Cross-National Research Project Incubation Signing Ceremony',
        type: 'ceremony',
        descZh: '7个跨国联合研究项目正式签约，覆盖基因编辑伦理、mRNA药物递送和AI辅助诊断三大主题',
        descEn: '7 cross-national joint research projects formally signed, covering three themes: gene editing ethics, mRNA drug delivery, and AI-assisted diagnosis',
      },
    ],
  },
  {
    eventId: 'gtf-2025',
    speakers: [],
    agenda: [
      {
        id: 'u1',
        time: '09:00 – 10:30',
        titleZh: '主旨演讲：净零之路——全球能源转型的最新进展',
        titleEn: 'Keynote: Path to Net Zero — Latest Progress in Global Energy Transition',
        type: 'keynote',
        descZh: '全面分析全球能源转型的当前进展，评估主要经济体的净零目标完成情况与政策挑战',
        descEn: 'Comprehensive analysis of current global energy transition progress, assessing net-zero target completion and policy challenges across major economies',
      },
      {
        id: 'u2',
        time: '11:00 – 12:30',
        titleZh: '技术展示：氢能突破与大规模储能新方案',
        titleEn: 'Tech Showcase: Hydrogen Breakthroughs & New Large-Scale Energy Storage Solutions',
        type: 'workshop',
        descZh: '来自全球15家机构展示氢能制备、储运与应用的最新技术突破，以及下一代固态电池研究进展',
        descEn: 'Latest technology breakthroughs in hydrogen production, storage, transportation, and application from 15 global institutions, along with next-generation solid-state battery research progress',
      },
      {
        id: 'u3',
        time: '14:00 – 15:30',
        titleZh: '圆桌：碳市场机制的全球协调与碳捕捉技术前景',
        titleEn: 'Roundtable: Global Carbon Market Coordination & Carbon Capture Technology Prospects',
        type: 'panel',
        descZh: '探讨全球碳市场的建立路径，分析DAC（直接空气碳捕捉）技术的成本曲线与规模化前景',
        descEn: 'Exploring pathways for global carbon market establishment and analyzing the cost curve and scaling prospects of DAC (Direct Air Carbon Capture) technology',
      },
      {
        id: 'u4',
        time: '16:00 – 17:30',
        titleZh: '绿色投资合作洽谈会',
        titleEn: 'Green Investment Partnership Matchmaking Session',
        type: 'ceremony',
        descZh: '150+企业代表参与一对一投资合作洽谈，达成多项绿色科技投资意向',
        descEn: '150+ corporate representatives participated in one-on-one investment partnership discussions, reaching multiple green technology investment intentions',
      },
    ],
  },
];
